import React from 'react'
import Yup from './../../../helpers/custom-yup'
import Button from '../../../components/buttons/buttons.component'
import styled from 'styled-components'
import StyledFlexContainer from './../../../components/containers/flex-container.component'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { breakpoints } from './../../../constants/breakpoints.constants'
import { CouponInput } from '../../../components/form-components/inputs.component'
import { toastActions } from '../../../actions'
import { bindActionCreators } from 'redux'
import { Creators as TicketSaleCreators } from '../../../ducks/ticket-sale/ticket-sale'
import TicketSaleService from './../../../services/ticket-sale.service'
import { UserService } from './../../../services/user.service'
import { CartService } from './../../../services/cart.service'
import { getApiErrorMessage } from './../../../services/axios.service'
import {
	ERROR_MSG_CALCULATED_VALUES,
	RoleConstants,
	PAYMENT_METHODS
} from '@constants'
import TripDiscountHelper from '../../../helpers/trip-discount.helper'
import { mapCartTotals, enrichTicket } from '@helpers'

class DiscountCouponComponent extends React.Component {
	constructor(props) {
		super(props)

		this.findCoupon = findCoupon.bind(this)
		this.renderFormik = renderFormik.bind(this)
		this.applyCouponToCart = applyCouponToCart.bind(this)
		this.applyCartSummary = applyCartSummary.bind(this)

		let couponPaymentMethod = 0
		if (props.paymentMethod === PAYMENT_METHODS.MUVICARD) {
			couponPaymentMethod = 2
		} else if (props.paymentMethod === PAYMENT_METHODS.PIX) {
			couponPaymentMethod = 3
		} else if (props.paymentMethod === PAYMENT_METHODS.CREDIT_CARD) {
			couponPaymentMethod = 1
		}

		this.state = {
			cleanValue: false,
			couponPaymentMethod
		}

		this._isMounted = false
	}

	componentDidMount() {
		this._isMounted = true
		if (!this.props.orderNumber) {
			// Anuncia que os totais estao em recalculo ANTES de aplicar o cupom: enquanto o
			// desconto nao volta, o total exibido e o de tabela, e quem depende dele (parcelamento)
			// mostraria valores que o cliente nao vai pagar. O `finally` de
			// applyAutomaticDiscountCoupon sempre desliga a flag, inclusive quando nenhum cupom
			// se aplica ou a chamada falha.
			this.props.setIsCalculatingValues(true)
			this.applyAutomaticDiscountCoupon()
		}
	}

	componentWillUnmount() {
		this._isMounted = false // Atualizar flag ao desmontar
	}

	/**
	 * Applies the best automatic coupon available for the cart (registration
	 * or route-based promotional), cascading server-side: carts/{id}/coupon/automatic
	 * tries the user-based coupon (Bearer) then falls back to the anonymous
	 * route-based one - no need to call each branch separately from here.
	 */
	async applyAutomaticDiscountCoupon() {
		if (!this._isMounted) return
		try {
			const { data } = await TicketSaleService.getAutomaticDiscountCoupon()

			const { coupon, discountApplied } = this.applyCartSummary(data)

			if (discountApplied) {
				this.refs.form.setFieldValue('code', coupon.code)
				this.props.setDiscountCoupon({
					isValid: true,
					code: coupon.code,
					discountPercentage: coupon.discountPercent,
					isPromotion: true
				})

				this.props.toastSuccess({
					message: `Cupom de desconto promocional de ${coupon.discountPercent}% de desconto foi aplicado!`
				})
			}
		} catch (error) {
			this.props.toastWarning({
				message: 'Erro ao buscar ou aplicar cupons promocionais.'
			})
		} finally {
			this.props.setIsCalculatingValues(false)
		}
	}

	render() {
		return (
			<Formik
				ref="form"
				validationSchema={schema}
				render={this.renderFormik}
				initialValues={initialValues}
			/>
		)
	}
}

const schema = Yup.object().shape({
	code: Yup.string()
})

const initialValues = {
	code: ''
}

function renderFormik(props) {
	const { isCpfChecked, user, paymentMethod } = this.props

	const isValidCPF = isCpfChecked || !!(user && user.cpf)

	// Meios de pagamento
	// Todos = 0,
	// Cartao = 1,
	// Muvicard = 2,
	// Pix = 3

	if (paymentMethod !== this.state.couponPaymentMethod) {
		let couponPaymentMethod = 0

		if (paymentMethod === PAYMENT_METHODS.MUVICARD) {
			couponPaymentMethod = 2
		} else if (paymentMethod === PAYMENT_METHODS.PIX) {
			couponPaymentMethod = 3
		} else if (paymentMethod === PAYMENT_METHODS.CREDIT_CARD) {
			couponPaymentMethod = 1
		}

		// Atualize o estado somente se necessário
		if (couponPaymentMethod !== this.state.couponPaymentMethod) {
			this.setState({ couponPaymentMethod })
		}
	}

	return (
		<StyledForm noValidate onSubmit={e => e.preventDefault()}>
			<StyledFlexContainer marginTop={0.1}>
				<CouponInput
					id="code"
					name="code"
					normalize
					{...props}
					maxLength={16}
					label="Código do cupom"
					className="col-3 coupon-input"
					style={{ textTransform: 'uppercase' }}
					toClean={this.state.cleanValue}
					disabled={!isValidCPF}
					setFieldValueHandler={() => {
						this.setState({
							cleanValue: false
						})
					}}
				/>
				<Button
					id="apply-coupon"
					className="apply-coupon"
					primary
					type="button"
					onClick={this.findCoupon}
					disabled={!isValidCPF}>
					Aplicar
				</Button>
				{!user && (
					<span className="warning-message">
						*É necessário informar um CPF válido nos dados de{' '}
						<strong>comprador</strong> para aplicar um cupom de desconto.
					</span>
				)}
			</StyledFlexContainer>
		</StyledForm>
	)
}

const StyledForm = styled.form`
	.coupon-input {
		margin-bottom: 2.5rem;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			margin-bottom: initial;
		}
	}
`

async function findCoupon() {
	const { toastWarning, resetDiscountCoupon, user } = this.props

	const isRequester = user && user.isRequester

	const {
		originGoing,
		destinationGoing,
		originReturn,
		destinationReturn,
		isCpfChecked
	} = this.props

	if (
		!isRequester &&
		(TripDiscountHelper.checkInvalidRoutes(originGoing, destinationGoing) ||
			TripDiscountHelper.checkInvalidRoutes(originReturn, destinationReturn))
	) {
		toastWarning({
			message: 'Cupom de desconto não aplicável em mercado compartilhado.'
		})

		this.setState({
			cleanValue: isCpfChecked || !!(user && user.cpf)
		})

		this.props.setIsCalculatingValues(false)

		resetDiscountCoupon()

		return
	}

	const { code } = this.refs.form.state.values
	const { familyDiscountParameters, familyDiscountApplied } = this.props

	const isTicketSalePage =
		window.location.pathname === '/cliente/compra-de-passagem'

	const { coupon, discountApplied } = await this.applyCouponToCart(code)

	if (!discountApplied) {
		resetDiscountCoupon()
		return
	}

	if (
		familyDiscountApplied &&
		isTicketSalePage &&
		familyDiscountParameters.percentDiscount >= coupon.discountPercent
	) {
		toastWarning({
			message: 'Você já possui o Desconto Família aplicado'
		})
		resetDiscountCoupon()
		return
	}

	this.props.setDiscountCoupon({
		isValid: true,
		code: coupon.code,
		discountPercentage: coupon.discountPercent
	})

	this.props.toastSuccess({
		message: `Seu cupom de ${coupon.discountPercent}% de desconto foi aplicado!`
	})
}

/**
 * Applies a coupon code to the current cart and, on success, updates
 * calculatedValues from the returned cart summary
 * @return {Promise<{coupon: object, discountApplied: boolean}>}
 */
async function applyCouponToCart(code) {
	this.props.setIsCalculatingValues(true)

	try {
		const { success, data } = await CartService.applyCoupon(code, this.props.cpf)

		if (!success) throw new Error()

		return this.applyCartSummary(data)
	} catch (error) {
		// This page (compra-de-passagem) is in axios.service.js's
		// toastIgnorePaths, so the global MuviHub error toast never fires
		// here - show it ourselves, or nothing gets shown at all.
		this.props.toastError({
			message: getApiErrorMessage(error) || ERROR_MSG_CALCULATED_VALUES
		})
		return { discountApplied: false }
	} finally {
		this.props.setIsCalculatingValues(false)
	}
}

/**
 * Updates calculatedValues (totals + per-seat prices) from a cart summary
 * returned by the coupon endpoints - the same way bus-seat-selection updates
 * the site after booking a seat (carts/{id}/seats).
 * @param {object} cart The cart summary: { coupon, totals, poltronas, ... }
 * @return {{coupon: object, discountApplied: boolean}}
 */
function applyCartSummary(cart) {
	const { coupon, totals, poltronas } = cart || {}
	const discountApplied = !!coupon

	if (discountApplied) {
		const { ticketsGoing, ticketsReturn } = this.props.calculatedValues
		const reprice = reapplyPoltronaPrice(poltronas || [])
		const mappedTotals = mapCartTotals(totals)

		this.props.setCalculatedValues({
			...mappedTotals,
			ticketsGoing: ticketsGoing.map(reprice),
			ticketsReturn: ticketsReturn.map(reprice)
		})

		this.props.setFamilyDiscountApplied(mappedTotals.hasFamilyDiscount)
	}

	return { coupon, discountApplied }
}

/**
 * Rebuilds a ticket's price breakdown from its matching `poltronas` entry
 * (matched by transactionId/resvId) - mirrors bus-seat-selection's own
 * price rebuild after booking a seat.
 */
function reapplyPoltronaPrice(poltronas) {
	return ticket => {
		const poltrona = poltronas.find(p => p.resvId === ticket.transactionId)

		if (!poltrona) return ticket

		const price = {
			fee: poltrona.serviceCharge,
			tax: poltrona.boardingTax,
			toll: poltrona.toll,
			insurance: poltrona.insurance,
			other: 0,
			value: poltrona.total,
			fare: poltrona.fare
		}

		return enrichTicket({ ...ticket, price, ...price })
	}
}

const mapStateToProps = store => ({
	discountCoupon: store.ticketSale.DiscountCoupon,
	isEtapaPagamento: TicketSaleSelectors.getEtapaPagamento(store),
	orderNumber: store.ticketSale.orderNumber,
	paymentMethod: store.ticketSale.paymentMethod,
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store),
	familyDiscountParameters: TicketSaleSelectors.getFamilyDiscountParameters(
		store
	),
	familyDiscountApplied: store.ticketSale.familyDiscountApplied
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastSuccess: toastActions.success,
			toastWarning: toastActions.warning,
			toastError: toastActions.danger,
			setDiscountCoupon: TicketSaleCreators.setDiscountCoupon,
			resetDiscountCoupon: TicketSaleCreators.resetDiscountCoupon,
			setCalculatedValues: TicketSaleCreators.setCalculatedValues,
			setIsCalculatingValues: TicketSaleCreators.setIsCalculatingValues,
			setFamilyDiscountApplied: TicketSaleCreators.setFamilyDiscountApplied
		},
		dispatch
	)

const DiscountCoupon = connect(
	mapStateToProps,
	mapDispatchToProps
)(DiscountCouponComponent)

export default DiscountCoupon
